import React from 'react';

import { Typography } from "@material-ui/core"

import Page from "../../Components/Page"

export default () => {
    return (
        <Page title="Styleguide">
            <Typography variant="h5">Links</Typography>

            <Typography variant="h5">Bilder</Typography>

            <Typography variant="h5">Videos</Typography>
            <Typography variant="subtitle1">(Instagram, Snapchat Filter, etc.)</Typography>
        </Page>
    )
}